var map = {
	"./de.json": 390,
	"./empty.json": 391,
	"./es.json": 392,
	"./fr.json": 393,
	"./it.json": 394,
	"./ja.json": 395,
	"./ko.json": 396,
	"./lt.json": 397,
	"./pt.json": 398,
	"./ru.json": 399,
	"./tr.json": 400,
	"./zh.json": 401
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 389;


//////////////////
// WEBPACK FOOTER
// ./src/js/languages \.json$
// module id = 389
// module chunks = 0